import Header from "../../components/seller-hub/header/Header";
import Seller from "../../layouts/seller-hub/Seller";
import Table from "../../layouts/seller-hub/Table";
import profile from "../../assets/profile-seller-hub-big.png";
import { useState } from "react";
import Button from "../../components/seller-hub/buttons/Button";
import ModalInput from "../../components/seller-hub/wallet/ModalInput";

const SellerProfile = () => {
  const [changePasswordDropdown, setChangePasswordDropdown] = useState(false);
  const [changeEmailDropdown, setChangeEmailDropdown] = useState(false);
  const [changeBankDetailsDropdown, setChangeBankDetailsDropdown] =
    useState(false);
  const [changeStorenameDropdown, setChangeStorenameDropdown] = useState(false);
  const [changeHouseAddressDropdown, setChangeHouseAddressDropdown] =
    useState(false);

  return (
    <div className="-mt-20 w-full">
      <Header />
      <Seller>
        <div className="mt-4 flex justify-center">
          <div className="w-[716px]">
            <div className="flex justify-between items-center">
              <div className="flex w-[40px] h-[40px] md:w-auto md:h-auto items-center gap-3">
                <img src={profile} alt="profile" />
                <div>
                  <p className="font-Lato font-bold text-base md:text-2xl">
                    Nnenna's Thrift
                  </p>
                  <p className="text-sm font-Lato font-semibold text-sidenavInactive">
                    Mail@nnenna.com
                  </p>
                </div>
              </div>

              <div>
                <button className="h-[44px] w-[120px] border-2 border-[#2F80ED] rounded text-[#2F80ED] font-bold font-Lato ">
                  Edit photo
                </button>
              </div>
            </div>
            <Table>
              <div className="w-full">
                <div className="h-11 text-sm md:text-base leading-[44px] border-b border-[#E9EAEC]">
                  <p>Contact info</p>
                </div>

                <div className=" w-full  border-b border-[#E9EAEC] text-sm md:text-base ">
                  <div className="flex leading-[44px] justify-between items-center">
                    <p className="">Store name</p>
                    {changeStorenameDropdown ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-chevron-up w-[17px] h-[17px]"
                        viewBox="0 0 16 16"
                        onClick={() => setChangeStorenameDropdown(false)}
                      >
                        <path
                          fillRule="evenodd"
                          d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-chevron-right "
                        viewBox="0 0 16 16"
                        onClick={() => setChangeStorenameDropdown(true)}
                      >
                        <path
                          fillRule="evenodd"
                          d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                        />
                      </svg>
                    )}
                  </div>
                  {changeStorenameDropdown && (
                    <div className="-mt-5">
                      <ModalInput type="text" placeholder="Nnenna" />
                      <div className="flex justify-end gap-5 pb-5 mt-3">
                        <button className="w-[80px] text-black rounded h-[44px] border-[0.5px] border-[#E9EAEC]">
                          Cancel
                        </button>
                        <Button width="w-[80px]" innerText="Save" />
                      </div>
                    </div>
                  )}
                </div>

                <div className=" w-full  border-b border-[#E9EAEC] text-sm md:text-base">
                  <div className="flex leading-[44px] justify-between items-center  ">
                    <p>Bank details</p>
                    <div className="flex gap-3 items-center">
                      <p className="font-Lato text-sm ">Nnnenna Ada</p>
                      {changeBankDetailsDropdown ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-chevron-up w-[17px] h-[17px]"
                          viewBox="0 0 16 16"
                          onClick={() => setChangeBankDetailsDropdown(false)}
                        >
                          <path
                            fillRule="evenodd"
                            d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
                          />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-chevron-right "
                          viewBox="0 0 16 16"
                          onClick={() => setChangeBankDetailsDropdown(true)}
                        >
                          <path
                            fillRule="evenodd"
                            d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                          />
                        </svg>
                      )}
                    </div>
                  </div>
                  {changeBankDetailsDropdown && <></>}
                </div>

                <div className=" w-full  border-b border-[#E9EAEC] text-sm md:text-base">
                  <div className="flex leading-[44px] justify-between items-center  ">
                    <p>House Address</p>
                    <div className="flex gap-3 items-center">
                      <p className="font-Lato text-sm ">
                        NO 12,Lagos street...
                      </p>
                      {changeHouseAddressDropdown ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-chevron-up w-[17px] h-[17px]"
                          viewBox="0 0 16 16"
                          onClick={() => setChangeHouseAddressDropdown(false)}
                        >
                          <path
                            fillRule="evenodd"
                            d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
                          />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-chevron-right "
                          viewBox="0 0 16 16"
                          onClick={() => setChangeHouseAddressDropdown(true)}
                        >
                          <path
                            fillRule="evenodd"
                            d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                          />
                        </svg>
                      )}
                    </div>
                  </div>
                  {changeHouseAddressDropdown && <></>}
                </div>
              </div>
            </Table>

            <Table>
              <div className="w-full">
                <div className="h-11 leading-[44px] border-b border-[#E9EAEC] text-sm md:text-base ">
                  <p>Security</p>
                </div>

                <div className=" w-full  border-b border-[#E9EAEC] text-sm md:text-base">
                  <div className="flex leading-[44px] justify-between items-center">
                    <p>Change Password</p>
                    {changePasswordDropdown ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-chevron-up w-[17px] h-[17px]"
                        viewBox="0 0 16 16"
                        onClick={() => setChangePasswordDropdown(false)}
                      >
                        <path
                          fillRule="evenodd"
                          d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-chevron-right "
                        viewBox="0 0 16 16"
                        onClick={() => setChangePasswordDropdown(true)}
                      >
                        <path
                          fillRule="evenodd"
                          d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                        />
                      </svg>
                    )}
                  </div>
                  {changePasswordDropdown && <></>}
                </div>

                <div className=" w-full  border-b border-[#E9EAEC] text-sm md:text-base">
                  <div className="flex leading-[44px] justify-between items-center">
                    <p>Change Email Address</p>
                    {changeEmailDropdown ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-chevron-up w-[17px] h-[17px]"
                        viewBox="0 0 16 16"
                        onClick={() => setChangeEmailDropdown(false)}
                      >
                        <path
                          fillRule="evenodd"
                          d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-chevron-right "
                        viewBox="0 0 16 16"
                        onClick={() => setChangeEmailDropdown(true)}
                      >
                        <path
                          fillRule="evenodd"
                          d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                        />
                      </svg>
                    )}
                  </div>
                  {changeEmailDropdown && <></>}
                </div>
              </div>
            </Table>
          </div>
        </div>
      </Seller>
    </div>
  );
};

export default SellerProfile;
